<template>
  <div>
    <el-dialog :title="titleStatus == 1 ? '开房' : '开位'" :visible.sync="check_in_visible" width="550" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" @close="onCloseCheckIn">
      <el-form ref="checkInForm" :rules="rules" label-width="100px" :model="checkInForm" label-position="left">
        <el-form-item label="使用时间：" :rules="{required: true, message: '请输入使用时间', trigger: 'blur'}">
          <span>{{ checkInForm.bookStartTime }}</span>
        </el-form-item>
        <el-form-item label="预离时间：" prop="bookEndTime" closeable="" :rules="{required: true, message: '请输入预离时间', trigger: 'blur'}">
          <el-date-picker v-model="checkInForm.bookEndTime" type="datetime" placeholder="选择时间" value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm" :picker-options="{
            disabledDate:disabledDate,
            selectableRange:selectableRange
          }" :editable="false"
          />
          <span>&nbsp;{{ onGetLastedTime(checkInForm.bookEndTime) }}</span>
        </el-form-item>
        <el-form-item v-if="titleStatus != 1" label="使用人数：" :rules="{required: true}">
          <span>{{ checkInForm.chooseRoom ? checkInForm.chooseRoom.length : 0 }}</span>
          <span>&nbsp;&nbsp;人</span>
        </el-form-item>
        <el-form-item v-if="titleStatus == 1" :label="'选择'+Lib.returnRoomOrBed()+'：'" :rules="[{required: true, message: '请选择'+Lib.returnRoomOrBed(), trigger: 'change'},{required: true, message: '请选择'+Lib.returnRoomOrBed(), trigger: 'blur'}]">
          <el-cascader ref="cascader" v-model="chooseRoomList" placeholder="请选择房间" :disabled="!(checkInForm.bookStartTime&&checkInForm.bookEndTime)" :options="roomList" :props="roomProps" clearable @change="chooseCascader">
            <template slot-scope="{ node, data }">
              <span style="float: left;">{{ data.name }}</span>
              <span v-if="node.isLeaf" style="float: right;padding-left: 20px;color: #C0C4CC;font-size: 13px;">{{ data.roomStatus == 1 ? '已锁定' : data.roomStatus == 2 ? '已预订' : data.roomStatus == 3 ? '已入住' : data.roomStatus == 5 ? '已退房' : data.roomStatus == 6 ? '已过期' : data.roomStatus == 7 ? '已超时' : '' }}</span>
            </template>
          </el-cascader>
          <el-button type="text" style="margin-left: 10px;" @click="relationship_visible = true">关联{{ Lib.returnRoomOrBed() }}</el-button>
        </el-form-item>
        <el-form-item v-else :label="'选择'+Lib.returnRoomOrBed()+'：'" prop="chooseRoom">
          <el-cascader v-model="checkInForm.chooseRoom" :disabled="!(checkInForm.bookStartTime&&checkInForm.bookEndTime)" :options="bedOptions" :props="bedProps" clearable :placeholder="'请选择'+Lib.returnRoomOrBed()" @change="chooseCascader">
            <template slot-scope="{ node, data }">
              <span>{{ data.name }}</span>
              <span v-if="!node.isLeaf" class="themeFC" style="float: right;padding-left: 20px;"> (剩余{{ data.lastRoomNum }}) </span>
              <span v-else style="float: right;padding-left: 20px;color: #C0C4CC;">{{ data.bedStatus == 1 ? '已锁定' : data.bedStatus == 2 ? '已预订' : data.bedStatus == 3 ? '已入住' : data.bedStatus == 5 ? '已退房' : data.bedStatus == 6 ? '已过期' : data.bedStatus == 7 ? '已超时' : '' }}</span>
            </template>
          </el-cascader>
          <el-button type="text" style="margin-left: 10px;" @click="relationship_visible = true">关联{{ Lib.returnRoomOrBed() }}</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <label class="colleagues" :class="titleStatus == 1 ? checkInForm.domains.length > 0 ? 'themeFC' : '' : checkInForm.chooseRoom ? checkInForm.chooseRoom.length > 0 ? 'themeFC' : '' : ''" @click="titleStatus == 1 ? checkInForm.domains.length > 0 ? addColleagues() : '' : checkInForm.chooseRoom ? checkInForm.chooseRoom.length > 0 ? addColleagues() : '' : ''"><i class="iconfont" :class="titleStatus == 1 ? checkInForm.domains.length > 0 ? 'themeFC' : '' : checkInForm.chooseRoom ? checkInForm.chooseRoom.length > 0 ? 'themeFC' : '' : ''">&#xe635;</i>同行人</label>
        <el-button @click="check_in_visible = false">取 消</el-button>
        <el-button type="primary" @click="confirmCheckIn">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="'关联'+Lib.returnRoomOrBed()" width="1000px" :visible.sync="relationship_visible" append-to-body>
      <p v-if="phoneNumber" style="font-weight: bold;">关联已预订{{ Lib.returnRoomOrBed() }}</p>
      <el-table v-if="phoneNumber" :key="Math.random()" class="roomTable" tooltip-effect="light" :data="relationship_data" style="margin:20px 0" max-height="360">
        <el-table-column prop="customerName" label="顾客姓名">
          <template slot-scope="scope">{{ scope.row.customerName || '--' }}</template>
        </el-table-column>
        <el-table-column prop="customerPhone" label="手机号码">
          <template slot-scope="scope">{{ scope.row.customerPhone || '--' }}</template>
        </el-table-column>
        <el-table-column :label="Lib.returnRoomOrBed()+'名称'" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-for="(v,n) in scope.row.bookRoomInfoList" :key="n">{{ v.roomName }}{{ v.bedName ? ('/'+v.bedName) : '' }}{{ scope.row.bookRoomInfoList.length == (n+1) ? '' : ',' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="bookStartTime" label="预订时间" width="160"></el-table-column>
        <el-table-column label="预订用离时间" width="280" :show-overflow-tooltip="true">
          <template slot-scope="scope">{{ scope.row.bookStartTime }} 至 {{ scope.row.bookEndTime }}</template>
        </el-table-column>
        <el-table-column label="操作" width="110" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-button v-if="scope.row.customerOrderId" type="text" size="mini">已关联</el-button>
            <el-button v-else type="primary" size="mini" @click="onRelationshipInfo(scope.row, scope.$index, 1)">{{ scope.row.relation == 1 ? '取消关联' : '关联' }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <p style="font-weight: bold;">关联已使用{{ Lib.returnRoomOrBed() }}</p>
      <el-table :key="Math.random()" class="roomTable" tooltip-effect="light" :data="usedData" style="margin:20px 0" max-height="360">
        <el-table-column prop="customerName" label="顾客姓名" :show-overflow-tooltip="true">
          <template slot-scope="scope">{{ scope.row.customerName || '--' }}</template>
        </el-table-column>
        <el-table-column prop="customerPhone" label="手机号码" :show-overflow-tooltip="true">
          <template slot-scope="scope">{{ scope.row.customerPhone || '--' }}</template>
        </el-table-column>
        <el-table-column :label="Lib.returnRoomOrBed()+'名称'" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-for="(v,n) in scope.row.bookRoomInfoList" :key="n">{{ v.roomName }}{{ v.bedName ? ('/'+v.bedName) : '' }}{{ scope.row.bookRoomInfoList.length == (n+1) ? '' : ',' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="beginTime" label="使用时间" width="160" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="endTime" label="预离时间" width="280" :show-overflow-tooltip="true">
          <template slot-scope="scope">{{ scope.row.endTime }}</template>
        </el-table-column>
        <el-table-column label="操作" width="110">
          <template slot-scope="scope">
            <span v-if="scope.row.customerOrderId" style="color: #333;">已关联</span>
            <el-button v-else type="primary" size="mini" @click="onRelationshipInfo(scope.row, scope.$index, 2)">{{ scope.row.relation == 1 ? '取消关联' : '关联' }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog title="添加同行人" class="deduction" :visible.sync="colleaguesDia" width="780px" append-to-body :close-on-click-modal="false">
      <el-table tooltip-effect="light" :data="newColleaguesData" row-key="id" :expand-row-keys="openListKey" max-height="600">
        <el-table-column prop="roomName" label="房间名称" :width="titleStatus == 1 ? 220 : 190" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <i v-show="scope.$index == chooseIndex" style="font-size: 18px;color: #D2D2D2;padding-right: 5px;" class="iconfont">&#xea44;</i>{{ scope.row.roomName }}
          </template>
        </el-table-column>
        <el-table-column v-if="titleStatus != 1" prop="bedName" :label="Lib.returnRoomOrBed()" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="顾客姓名" width="180">
          <template slot-scope="scope">
            <el-input v-model="scope.row.name" :disabled="(scope.$index == chooseIndex && phoneNumber) ? true : false" size="mini" :maxlength="15" style="width: 150px;"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="电话号码" :width="titleStatus == 1 ? '210' : '180'">
          <template slot-scope="scope">
            <el-input v-model="scope.row.phone" :disabled="(scope.$index == chooseIndex && phoneNumber) ? true : false" size="mini" style="width: 150px;" :maxlength="11" @change="checkPhone(scope.row.phone,scope.$index,1)"></el-input>
            <i v-if="titleStatus == 1" class="iconfont el-icon-circle-plus themeFC" style="font-size: 26px;position: relative;top: 4px;margin-left: 10px;cursor: pointer;" @click="addAndSubMember(1,scope.$index)"></i>
          </template>
        </el-table-column>
        <el-table-column v-if="titleStatus == 1" type="expand" width="10">
          <template slot-scope="scope">
            <div class="tableExpandList">
              <div v-for="(v,n) in scope.row.chooseList" :key="n" class="li">
                <el-input v-model="v.name" size="mini" class="tinputOne" :maxlength="15"></el-input>
                <el-input v-model="v.phone" size="mini" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{})[\d+\.]/g, '')" class="tinputTwo" :maxlength="11" @change="checkPhone(v.phone,scope.$index,2,n)"></el-input>
                <i class="iconfont el-icon-remove" @click="addAndSubMember(2,scope.$index,n)"></i>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column v-if="!id" width="100">
          <template slot-scope="scope">
            <el-button v-show="scope && scope.$index != chooseIndex" type="text" @click="setIssuer(scope.$index,scope.row)">设为开单人</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <label class="colleagues"><i style="font-size: 18px;color: #D2D2D2;padding-right: 5px;font-weight: 500;" class="iconfont">&#xea44;</i>为开单人，不填写同行人信息时，房态顾客信息将直接使用开单人信息</label>
        <el-button @click="confirmCancel">取 消</el-button>
        <el-button type="primary" @click="confirmAdd">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { getRoomRelationDetails, getChooseRoomInfo } from '../api';

export default {
  name: 'CheckIntoRoom',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    phoneNumber: {
      type: String,
      default: ''
    },
    checkInData: {
      type: Object,
      default: () => { }
    },
    titleStatus: {
      type: String,
      default: String
    },
    id: {
      type: String,
      default: String
    },
  },
  data() {
    const validateRoom = (rule, value, callback) => {
      if (this.checkInForm.chooseRoom) {
        if (this.checkInForm.chooseRoom.length > 0) {
          callback();
        } else {
          return callback(new Error(`请选择${this.titleStatus == 2 ? '床位' : '台位'}`));
        }
      } else {
        return callback(new Error(`请选择${this.titleStatus == 2 ? '床位' : '台位'}`));
      }
    };
    return {
      check_in_visible: false, // 控制弹窗的开关
      checkInForm: {
        bookStartTime: '',
        bookEndTime: '',
        domains: [],
        chooseRoom: []
      }, // 开房的表单
      relationship_visible: false, // 关联表格弹窗
      relationship_data: [], // 关联表格数据
      selectableRange: '00:00:00 - 23:59:59', // 限制预离时间范围
      roomList: [], // 可选择房间列表
      // 以下是关联数据专用
      customerName: '',
      customerPhone: '',
      memberType: 0, // 会员类型（0:普通顾客，1:会员）
      relation_beginTime: '',
      relation_endTime: '',

      // 5.10
      colleaguesDia: false, // 添加同行人弹窗
      colleaguesData: [],
      newColleaguesData: [],
      bedOptions: [],
      rules: {
        chooseRoom: [
          { required: true, validator: validateRoom, trigger: 'change' },
          { required: true, validator: validateRoom, trigger: 'blur' }
        ]
      },
      openListKey: [],
      // 6.8
      chooseIndex: 0, // 选择哪个同行人为开单人
      confirmChooseIndex: 0,
      chooseRoomList: [],
      usedData: [],
      bedProps: {
        multiple: true, value: 'id', label: 'name', children: 'roomBedInfoList'
      },
      roomProps: {
        multiple: true, value: 'id', label: 'name'
      },
    };
  },
  watch: {
    show(val) {
      if (val) {
        let checkInForm = {};
        this.customerName = this.$parent.MemberInfo.nickName;
        this.customerPhone = this.$parent.MemberInfo.phone || this.$parent.form.phone;
        this.memberType = this.$parent.cardNo ? 1 : 0;
        this.relation_beginTime = '';
        this.relation_endTime = '';
        if (this.checkInData.is_edit == 1) {
          checkInForm = {
            bookStartTime: this.checkInData.roomInfosList[0].bookStartTime || this.checkInData.roomInfosList[0].beginTime,
            bookEndTime: this.checkInData.roomInfosList[0].bookEndTime || this.checkInData.roomInfosList[0].endTime,
            domains: [],
            chooseRoom: [],
            isRelation: this.checkInData.isRelation
          };
          this.chooseRoomList = [];
        } else {
          checkInForm = {
            bookStartTime: this.checkInData.roomInfosList[0].bookStartTime
              ? this.checkInData.roomInfosList[0].bookStartTime
              : dayjs().format('YYYY-MM-DD HH:mm'),
            bookEndTime: this.checkInData.roomInfosList[0].bookEndTime
              ? this.checkInData.roomInfosList[0].bookEndTime
              : '',
            domains: [],
            chooseRoom: [],
            isRelation: this.checkInData.isRelation
          };
          this.chooseRoomList = [];
        }
        if (this.titleStatus == 1) {
          this.checkInData.roomInfosList.forEach((list) => {
            checkInForm.domains.push({
              peopleNumber: list.peopleNumber,
              roomId: list.roomId,
              roomOrderId: list.roomOrderId ? list.roomOrderId : null
            });
            if (list.roomId) {
              this.chooseRoomList.push(list.roomId);
            }
          });
        } else {
          this.checkInData.roomInfosList.forEach((list, index) => {
            if (index == 0) {
              checkInForm.domains.push({
                peopleNumber: list.peopleNumber,
                roomId: list.roomId,
                roomOrderId: list.roomOrderId ? list.roomOrderId : null
              });
            }
            if (list.roomBedId) {
              checkInForm.chooseRoom.push([list.roomId, list.roomBedId]);
            }
          });
        }
        if (this.checkInData.roomInfosList[0].roomName === '') {
          this.chooseRoomList = [];
          this.checkInForm.chooseRoom = [];
        }
        console.log(this.checkInData, checkInForm, this.chooseRoomList, this.checkInForm.chooseRoom);
        this.checkInForm = checkInForm; // 开房的表单
        this.openRelationshipTable();
        this.check_in_visible = val;
      }
    },
    checkInForm: {
      handler(newName) {
        if (newName.bookStartTime && newName.bookEndTime) {
          this.onGetRoomInfo(newName.bookStartTime, newName.bookEndTime);
        }
      },
      immediate: true,
      deep: true
    }
  },
  deactivated() {
    this.newColleaguesData = [];
    this.colleaguesData = [];
  },
  methods: {
    setIssuer(index, obj) {
      if (!obj.phone) {
        this.$message('请输入开单人手机号码');
        return;
      }
      if (!obj.name) {
        this.$message('请输入开单人姓名');
        return;
      }
      this.chooseIndex = index;
    },
    // 检查手机号码正确与否
    checkPhone(val, index, status, n) {
      if (val && !this.Lib.CheckPhone(val)) {
        this.$message('您输入的手机号码有误，请重新输入');
        if (status == 1) {
          this.newColleaguesData[index].phone = '';
        } else {
          this.newColleaguesData[index].chooseList[n].phone = '';
        }
      }
    },
    chooseCascader() {
      const arr = [];
      const vm = this;
      if (this.titleStatus == 1) {
        vm.chooseRoomList.forEach((a, n) => {
          vm.roomList.forEach((b) => {
            if (a == b.id) {
              const obj = {};
              obj.roomId = b.id;
              obj.roomName = b.name;
              obj.bedId = '';
              obj.bedName = '';
              obj.roomOrderId = vm.getRoomOrderId(b.id, '');
              obj.isRelation = this.colleaguesData[n] ? this.colleaguesData[n].isRelation : '';
              obj.phone = vm.colleaguesData[n] ? vm.colleaguesData[n].phone : (vm.checkInData.roomInfosList[n] ? vm.checkInData.roomInfosList[n].customerPhone : '');
              obj.name = vm.colleaguesData[n] ? vm.colleaguesData[n].name : (vm.checkInData.roomInfosList[n] ? vm.checkInData.roomInfosList[n].customerName : '');
              obj.chooseList = vm.colleaguesData[n] ? (vm.colleaguesData[n].chooseList || []) : (vm.checkInData.roomInfosList[n] ? (vm.checkInData.roomInfosList[n].dtoList || []) : []);
              arr.push(obj);
            }
          });
        });
      } else {
        this.checkInForm.chooseRoom.forEach((a, n) => {
          this.bedOptions.forEach((b) => {
            if (a[0] == b.id) {
              b.roomBedInfoList.forEach((c) => {
                if (a[1] == c.id) {
                  const obj = {};
                  obj.roomId = b.id;
                  obj.roomName = b.name;
                  obj.bedId = c.id;
                  obj.bedName = c.name;
                  obj.roomOrderId = vm.getRoomOrderId(b.id, c.id);
                  obj.isRelation = this.colleaguesData[n] ? this.colleaguesData[n].isRelation : '';
                  obj.phone = vm.colleaguesData[n] ? vm.colleaguesData[n].phone : (vm.checkInData.roomInfosList[n] ? vm.checkInData.roomInfosList[n].customerPhone : '');
                  obj.name = vm.colleaguesData[n] ? vm.colleaguesData[n].name : (vm.checkInData.roomInfosList[n] ? vm.checkInData.roomInfosList[n].customerName : '');
                  obj.chooseList = vm.colleaguesData[n] ? (vm.colleaguesData[n].chooseList || []) : (vm.checkInData.roomInfosList[n] ? (vm.checkInData.roomInfosList[n].dtoList || []) : []);
                  arr.push(obj);
                }
              });
            }
          });
        });
      }
      this.colleaguesData = arr;
      this.$forceUpdate();
    },
    confirmCancel() {
      this.colleaguesDia = false;
    },
    confirmAdd() {
      this.colleaguesDia = false;
      this.confirmChooseIndex = JSON.parse(JSON.stringify(this.chooseIndex));
      this.colleaguesData = JSON.parse(JSON.stringify(this.newColleaguesData));
      this.checkList();
    },
    // 添加或者删除同行人
    addAndSubMember(val, index, num) {
      if (val == 1) {
        this.newColleaguesData[index].chooseList.push({ name: '', phone: '' });
      } else {
        this.newColleaguesData[index].chooseList.splice(num, 1);
      }
      this.checkList();
    },
    // 5.10校验展开列表
    checkList() {
      this.openListKey = [];
      this.newColleaguesData.forEach((a) => {
        if (a.chooseList.length > 0) {
          this.openListKey.push(a.id);
        }
      });
    },
    // 5.10添加同行人--弹出窗
    addColleagues() {
      this.colleaguesDia = true;
      this.chooseIndex = JSON.parse(JSON.stringify(this.confirmChooseIndex));
      this.colleaguesData.forEach((v, n) => {
        if (n == 0) {
          v.name = v.name || this.customerName || '新增顾客';
          v.phone = v.phone || this.customerPhone;
        }
      });
      this.newColleaguesData = JSON.parse(JSON.stringify(this.colleaguesData));
      this.checkList();
    },
    // 关闭弹窗的回调
    onCloseCheckIn() {
      // 修改父组件绑定的show组件的值
      this.$emit('update:show', this.check_in_visible);
    },
    // 请求关联列表的数据
    openRelationshipTable() {
      const vm = this;
      const data = {
        mainId: sessionStorage.getItem('mainId'),
        customerOrderId: this.id,
        phone: this.phoneNumber
      };
      getRoomRelationDetails(data).then((res) => {
        if (res.code === 0) {
          res.data.customerBookInfo = res.data.customerBookInfo || [];
          res.data.customerBookInfo.forEach((a) => {
            a.formatter_createTime = dayjs(a.createTime).format(
              'YYYY-MM-DD HH:mm'
            );
            if (vm.relationship_data.length == 0) {
              a.relation = 0;
              a.isRelation = 0;
            } else {
              vm.relationship_data.forEach((b) => {
                if (a.bookFlag == b.bookFlag) {
                  a.relation = b.relation;
                  a.isRelation = b.isRelation;
                }
              });
            }
          });
          vm.relationship_data = res.data.customerBookInfo;
          res.data.customerCheckInfo = res.data.customerCheckInfo || [];
          res.data.customerCheckInfo.forEach((a) => {
            a.formatter_createTime = dayjs(a.createTime).format(
              'YYYY-MM-DD HH:mm'
            );
            if (vm.usedData.length == 0) {
              a.relation = 0;
              a.isRelation = 0;
            } else {
              vm.usedData.forEach((b) => {
                if (a.bookFlag == b.bookFlag) {
                  a.isRelation = b.isRelation;
                }
              });
            }
          });
          vm.usedData = res.data.customerCheckInfo;
        }
      });
    },
    // 获取关联的状态是否可关联
    getDisabledStatus(obj) {
      let status = 0;
      if (this.titleStatus == 1) {
        this.chooseRoomList.forEach((a) => {
          obj.bookRoomInfoList.forEach((b) => {
            if (a == b.roomId) {
              status = 1;
            }
          });
        });
        return status == 1;
      }
      this.checkInForm.chooseRoom.forEach((a) => {
        obj.bookRoomInfoList.forEach((b) => {
          if (a[0] == b.roomId && a[1] == b.id) {
            status = 1;
          }
        });
      });
      return status == 1;
    },
    // 关联列表里的关联按钮
    onRelationshipInfo(row, index, status) {
      if (row.relation == 0 && this.getDisabledStatus(row)) {
        this.$message(`不能关联相同的${this.Lib.returnRoomOrBed()}`);
        return;
      }
      if (row.relation == 1) {
        if (status == 1) {
          this.relationship_data[index].relation = 0;
          this.relationship_data[index].isRelation = 0;
        } else {
          this.usedData[index].relation = 0;
          this.usedData[index].isRelation = 0;
        }
        if (this.titleStatus == 2 || this.titleStatus == 3) {
          const indexVal = [];
          row.bookRoomInfoList.forEach((a) => {
            this.checkInForm.chooseRoom.forEach((b, n) => {
              if (a.roomId == b[0]) {
                indexVal.push(n);
              }
            });
          });
          indexVal.forEach((a) => {
            this.checkInForm.chooseRoom.splice(a, 1);
            this.colleaguesData.splice(a, 1);
          });
        } else {
          const indexVal = [];
          row.bookRoomInfoList.forEach((a) => {
            this.chooseRoomList.forEach((b, n) => {
              if (a.roomId == b) {
                indexVal.push(n);
              }
            });
          });
          indexVal.forEach((a) => {
            this.checkInForm.domains.splice(a, 1);
            this.chooseRoomList.splice(a, 1);
            this.colleaguesData.splice(a, 1);
          });
        }
      } else {
        if (status == 1) {
          this.relationship_data[index].relation = 1;
          this.relationship_data[index].isRelation = 1;
        } else {
          this.usedData[index].relation = 1;
          this.usedData[index].isRelation = 1;
        }
        this.checkInForm.bookEndTime = status == 1 ? row.bookEndTime : row.endTime;
        this.relation_beginTime = status == 1 ? row.bookStartTime : row.beginTime;
        this.relation_endTime = status == 1 ? row.bookEndTime : row.endTime;
        if (this.titleStatus == 2 || this.titleStatus == 3) {
          row.bookRoomInfoList.forEach((a) => {
            const obj = [a.roomId, a.roomBedId];
            this.checkInForm.chooseRoom.push(obj);
          });
          row.bookRoomInfoList.forEach((b, m) => {
            const obj = {};
            obj.customerId = b.lookRoomLodgerList[0].id;
            obj.roomId = b.roomId;
            obj.roomName = b.roomName;
            obj.bedId = b.roomBedId;
            obj.bedName = b.bedName;
            obj.roomOrderId = b.roomOrderId;
            obj.isRelation = 1;
            obj.phone = m == 0 ? row.customerPhone : b.lookRoomLodgerList[0].customerPhone;
            obj.name = m == 0 ? row.customerName : b.lookRoomLodgerList[0].customerName;
            obj.chooseList = [];
            b.lookRoomLodgerList.forEach((c) => {
              const nObj = {};
              nObj.customerId = c.id;
              nObj.customerType = c.customerType;
              nObj.logInfo = c.logInfo;
              nObj.name = c.customerName;
              nObj.phone = c.customerPhone;
              obj.chooseList.push(nObj);
            });
            this.colleaguesData.push(obj);
          });
        } else {
          row.bookRoomInfoList.forEach((a) => {
            const obj = {};
            obj.peopleNumber = 1;
            obj.roomId = a.roomId;
            this.checkInForm.domains.push(obj);
            this.chooseRoomList.push(a.roomId);
          });
          row.bookRoomInfoList.forEach((b, m) => {
            const obj = {};
            obj.roomId = b.roomId;
            obj.roomName = b.roomName;
            obj.bedId = '';
            obj.bedName = '';
            obj.roomOrderId = b.roomOrderId;
            obj.isRelation = 1;
            obj.phone = m == 0 ? row.customerPhone : b.lookRoomLodgerList[0].customerPhone;
            obj.name = m == 0 ? row.customerName : b.lookRoomLodgerList[0].customerName;
            obj.chooseList = [];
            b.lookRoomLodgerList.forEach((c, n) => {
              const nObj = {};
              nObj.customerId = c.id;
              nObj.customerType = c.customerType;
              nObj.logInfo = c.logInfo;
              nObj.name = c.customerName;
              nObj.phone = c.customerPhone;
              if (n > 0) {
                obj.chooseList.push(nObj);
              }
            });
            this.colleaguesData.push(obj);
          });
        }
      }
      console.log(this.colleaguesData);
      this.$forceUpdate();
      if (row.peopleNumber > row.lastRoomNum) {
        this.$message.error(`房间剩余${this.Lib.returnRoomOrBed()}数不足 请重新选择房间`);
      }
    },
    // 返回禁用时间
    disabledDate(time) {
      if (this.checkInForm.bookEndTime) {
        if (dayjs().isAfter(dayjs(this.checkInForm.bookEndTime, 'day'))) {
          this.selectableRange = `${dayjs(this.checkInForm.bookStartTime)
            .add(10, 'minute')
            .format('HH:mm:ss')} - 23:59:59`;
          this.checkInForm.bookEndTime = dayjs(this.checkInForm.bookStartTime)
            .add(10, 'minute')
            .format('YYYY-MM-DD HH:mm');
          // this.checkInForm.bookEndTime = dayjs(this.checkInForm.bookStartTime).add(10, 'minute').format("HH:mm:ss");
          // console.log(this.selectableRange, this.checkInForm.bookEndTime);
        } else {
          this.selectableRange = '00:00:00 - 23:59:59';
        }
      }
      return time.getTime() < Date.now() - 8.64e7;
    },
    // 计算服务时长
    onGetLastedTime(time) {
      const millisecond = dayjs(time).diff(
        dayjs(this.checkInForm.bookStartTime),
        'millisecond'
      );
      // const dateBegin = new Date(this.checkInForm.bookStartTime);
      // const dateEnd = new Date(this.checkInForm.bookEndTime);
      // 计算相差天钟数
      const dayDiff = Math.floor(millisecond / (24 * 3600 * 1000)); // 计算出相差天数
      // 计算相差小时数
      const leave1 = millisecond % (24 * 3600 * 1000); // 计算天数后剩余的毫秒数
      const hours = Math.floor(leave1 / (3600 * 1000)); // 计算出小时数
      // 计算相差分钟数
      const leave2 = leave1 % (3600 * 1000); // 计算小时数后剩余的毫秒数
      const minutes = Math.floor(leave2 / (60 * 1000)); // 计算相差分钟数
      return `共${dayDiff || ''}${dayDiff ? '天' : ''}${
        hours || ''
      }${hours ? '小时' : ''}${minutes || 0}分钟`;
    },
    getRoomOrderId(roomId, bedId) {
      const vm = this;
      if (this.checkInData.is_edit == 1) {
        if (vm.titleStatus == 1) {
          let val = '';
          this.checkInData.roomInfosList.forEach((a) => {
            if (a.roomId == roomId) {
              val = a.roomOrderId;
            }
          });
          return val;
        }
        let val = '';
        this.checkInData.roomInfosList.forEach((a) => {
          if (a.roomId == roomId && a.roomBedId == bedId) {
            val = a.roomOrderId;
          }
        });
        return val;
      }
      console.log(this.colleaguesData);
      if (vm.titleStatus == 1) {
        let val = '';
        this.colleaguesData.forEach((a) => {
          if (a.roomId == roomId) {
            val = a.roomOrderId;
          }
        });
        return val;
      }
      let val = '';
      this.colleaguesData.forEach((a) => {
        if (a.roomId == roomId && a.roomBedId == bedId) {
          val = a.roomOrderId;
        }
      });
      return val;
    },
    // 获取房间列表
    onGetRoomInfo(bookStartTime, bookEndTime) {
      const vm = this;
      const data = {
        mainId: sessionStorage.getItem('mainId'),
        bookStartTime,
        bookEndTime
      };
      if (vm.titleStatus == 1) {
        getChooseRoomInfo(data).then((res) => {
          vm.roomList = res.data.chooseRoomInfoList;
          const arr = [];
          vm.chooseRoomList.forEach((a, n) => {
            vm.roomList.forEach((b) => {
              if (a == b.id) {
                console.log('123123');
                const obj = {};
                obj.roomId = b.id;
                obj.roomName = b.name;
                obj.bedId = '';
                obj.bedName = '';
                obj.roomOrderId = vm.getRoomOrderId(b.id, '');
                obj.isRelation = b.isRelation;
                obj.phone = vm.colleaguesData[n] ? vm.colleaguesData[n].phone : (vm.checkInData.roomInfosList[n] ? vm.checkInData.roomInfosList[n].customerPhone : '');
                obj.name = vm.colleaguesData[n] ? vm.colleaguesData[n].name : (vm.checkInData.roomInfosList[n] ? vm.checkInData.roomInfosList[n].customerName : '');
                obj.chooseList = vm.colleaguesData[n] ? vm.colleaguesData[n].chooseList : (vm.checkInData.roomInfosList[n] ? vm.checkInData.roomInfosList[n].dtoList : []);
                arr.push(obj);
              }
            });
          });
          console.log(arr);
          vm.colleaguesData = arr;
          vm.$forceUpdate();
        });
      } else {
        getChooseRoomInfo(data).then((res) => {
          if (res.code == 0) {
            vm.bedOptions = res.data.chooseRoomInfoList;
            const arr = [];
            vm.checkInForm.chooseRoom.forEach((a, n) => {
              vm.bedOptions.forEach((b) => {
                if (a[0] == b.id) {
                  b.roomBedInfoList.forEach((c) => {
                    if (a[1] == c.id) {
                      const obj = {};
                      obj.roomId = b.id;
                      obj.roomName = b.name;
                      obj.bedId = c.id;
                      obj.bedName = c.name;
                      obj.roomOrderId = vm.getRoomOrderId(b.id, c.id);
                      obj.isRelation = vm.colleaguesData[n] ? vm.colleaguesData[n].isRelation : '';
                      obj.phone = vm.colleaguesData[n] ? vm.colleaguesData[n].phone : (vm.checkInData.roomInfosList[n] ? vm.checkInData.roomInfosList[n].customerPhone : '');
                      obj.name = vm.colleaguesData[n] ? vm.colleaguesData[n].name : (vm.checkInData.roomInfosList[n] ? vm.checkInData.roomInfosList[n].customerName : '');
                      obj.chooseList = vm.colleaguesData[n] ? vm.colleaguesData[n].chooseList : [];
                      arr.push(obj);
                    }
                  });
                }
              });
            });
            vm.colleaguesData = arr;
            vm.$forceUpdate();
          } else {
            console.log(res);
          }
        });
      }
    },
    // 点击确定
    confirmCheckIn() {
      const vm = this;
      vm.$refs.checkInForm.validate((valid) => {
        if (valid) {
          if (vm.titleStatus == 1) {
            const dto = {
              bookStartTime: vm.relation_beginTime,
              buySource: 0, // 写死的 不用管
              customerName: vm.colleaguesData[vm.confirmChooseIndex].name,
              customerPhone: vm.colleaguesData[vm.confirmChooseIndex].phone,
              bookEndTime: vm.relation_endTime,
              memberType: vm.memberType,
              roomInfosList: []
            };
            this.colleaguesData.forEach((b, m) => {
              const obj = {};
              obj.bookStartTime = vm.checkInForm.bookStartTime;
              obj.customerId = b.customerId;
              obj.customerName = m == vm.confirmChooseIndex ? (vm.colleaguesData[vm.confirmChooseIndex].name || this.customerName || '同行顾客') : b.name;
              obj.customerPhone = m == vm.confirmChooseIndex ? (vm.colleaguesData[vm.confirmChooseIndex].phone || this.customerPhone) : b.phone;
              obj.customerType = m == vm.confirmChooseIndex ? 0 : 1;
              const nArr = [{ name: (b.name || '同行顾客'), phone: b.phone }];
              b.chooseList.forEach((c) => {
                if (c.name == '') {
                  c.name = '同行顾客';
                }
                nArr.push(c);
              });
              obj.dtoList = (m == vm.confirmChooseIndex ? b.chooseList : nArr);
              obj.bookEndTime = vm.checkInForm.bookEndTime;
              obj.roomOrderId = b.roomOrderId;
              obj.isRelation = b.isRelation;
              obj.memberType = vm.memberType;
              obj.peopleNumber = null;
              obj.remarks = '';
              obj.roomBedId = '';
              obj.roomName = b.roomName;
              obj.roomId = b.roomId;
              dto.roomInfosList.push(obj);
            });
            console.log(dto);
            vm.$emit('update', dto);
          } else {
            const dto = {
              bookStartTime: vm.relation_beginTime,
              buySource: 0, // 写死的 不用管
              customerName: vm.colleaguesData[vm.confirmChooseIndex].name,
              customerPhone: vm.colleaguesData[vm.confirmChooseIndex].phone,
              bookEndTime: vm.relation_endTime,
              memberType: vm.memberType,
              roomInfosList: []
            };
            vm.colleaguesData.forEach((a, n) => {
              const obj = {};
              obj.bookStartTime = vm.checkInForm.bookStartTime;
              obj.customerId = a.customerId;
              obj.customerName = n == vm.confirmChooseIndex ? (vm.colleaguesData[vm.confirmChooseIndex].name || this.customerName || '同行顾客') : a.name;
              obj.customerPhone = n == vm.confirmChooseIndex ? (vm.colleaguesData[vm.confirmChooseIndex].phone || this.customerPhone) : a.phone;
              obj.customerType = n == vm.confirmChooseIndex ? 0 : 1;
              obj.dtoList = [];
              obj.bookEndTime = vm.checkInForm.bookEndTime;
              obj.roomOrderId = a.roomOrderId;
              obj.isRelation = a.isRelation;
              obj.memberType = vm.memberType;
              obj.peopleNumber = 1;
              obj.remarks = '';
              obj.roomBedId = a.bedId;
              obj.bedName = a.bedName;
              obj.roomName = a.roomName;
              obj.roomId = a.roomId;
              dto.roomInfosList.push(obj);
            });
            vm.$emit('update', dto);
          }
          vm.check_in_visible = false;
        } else {
          return false;
        }
      });
    },
  }
};
</script>
<style>
.deduction .el-table__expand-icon {
  display: none;
}
.deduction .el-table__expanded-cell {
  padding: 0 !important;
}
.deduction .el-dialog__body {
  overflow: hidden !important;
}
.roomTable tbody tr:hover>td {
  background-color:transparent!important;
}
</style>

<style lang="less" scoped>
.tableExpandList {
  list-style: none;
  .li {
    padding-left: 220px;
    height: 53px;
    line-height: 53px;
    border-bottom: 1px solid #e6ebf5;
    .tinputOne {
      width: 150px;
      margin: 0 20px 0 10px;
    }
    .tinputTwo {
      width: 150px;
      margin: 0 10px 0 10px;
    }
    i {
      font-size: 26px;
      position: relative;
      top: 4px;
      color: #989C98;
      cursor: pointer;
    }
  }
  .li:last-child {
    border-bottom: 0;
  }
}
</style>
